import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {AuthRedirectParents, PostJSON, ServerImage} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {BreadCrumbs} from "../../../components/open/pages";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const StudentsViewNewsScreen = () => {
    const {newsNd} = useParams();
    const [data, setData] = useState({
        loaded: false,
        title: '',
        body: '',
        category: '',
        hasSignup: false,
        hasSignedUp: false,
        img: '',
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/parents/news/get',
            {nd: newsNd as string},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                title: string,
                body: string,
                img: string,
                category: string,
                signup: 0 | 1,
                hasSignedUp: boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                setData({
                    loaded: true,
                    title: d.title,
                    category: d.category,
                    hasSignedUp: d.hasSignedUp,
                    img: d.img,
                    body: d.body,
                    hasSignup: d.signup === 1,
                });
            },
            () => {
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "مشاهده اطلاعیه | نهال";
        fetchData();
    }, []);
    const requestSignup = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/news/signup',
            {nd: newsNd as string},
            true,
            (d: {
                result: string,
                reason: undefined | 'login',
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                ShowProgressLoading();
                fetchData();
                ShowSnackbar(
                    'ثبت‌نام شما در این برنامه انجام شد.',
                    'باشه',
                    5000,
                );
            },
            () => {
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    return (
        <>
            <BreadCrumbs links={[
                {title: 'پنل دانش‌آموزان', url: '/students/'},
                {title: 'اطلاعیه‌ها', url: '/students/news'},
                {title: data.title, url: `/students/news/view/${newsNd}`},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="row justify-content-center">
                            <div className="col-lg-7">
                                <div className="sci-class-view">
                                    <em style={{backgroundImage: `url(${ServerImage(data.img, 500)})`}}/>
                                    <b>{data.title}</b>
                                    <i>{data.category}</i>
                                    <p>{data.body}</p>
                                    {
                                        data.hasSignup ?
                                            <div className="sci-class-view-feature">
                                                <span>وضعیت: </span>
                                                <b>{data.hasSignedUp ? 'ثبت‌نام شده' : 'ثبت‌نام نشده'}</b>
                                            </div> : null
                                    }
                                    {
                                        data.hasSignup && !data.hasSignedUp ?
                                            <div className="d-flex justify-content-end align-items-center"
                                                 style={{padding: '20px 20px 0 20px'}}>
                                                <button className="btn-pay" onClick={requestSignup}>
                                                    <b>درخواست ثبت‌نام</b>
                                                </button>
                                            </div> : null

                                    }
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
        </>
    );
};